import { render, staticRenderFns } from "./edutalk-footer.vue?vue&type=template&id=41e2edee"
import script from "./edutalk-footer.vue?vue&type=script&lang=js"
export * from "./edutalk-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports